import { JSX } from 'react';
import { ComponentProps } from 'lib/component-props';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';

/* This component is a seam in the layout infrastructure to avoid using SideNavContainer where it is not required
Instead, this component implements a simple centered-layout and a tailwind group "group/modern"
The tailwind group is necessary because currently components implement their own margin and padding
unless those components are a child of the Side Nav Container. This approach allows a component to override those defaults.
For examples, see InPageBanner.tsx and RTE.tsx as well as the ComponentWrapper.tsx file.
 */
export const Default = (props: ComponentProps): JSX.Element => {
  const { RenderingIdentifier } = props?.params || {};

  return (
    <div>
      <PlaceholderWrapper name="cw-general-header" rendering={props.rendering} />
      <div
        className={'group/modern w-full px-10 lg:px-20 max-w-[898px] mx-auto pt-24 pb-24'}
        data-component="authorable/shared/layout/CenteredContainer"
        id={RenderingIdentifier}
      >
        <PlaceholderWrapper name="cw-centered-container" rendering={props.rendering} />
      </div>
    </div>
  );
};
